export const OFFLINE_SYNC_QUEUE_KEY = 'audit_form_offline_sync_queue';

const normalizeKeyPart = (value) => String(value || '').trim();

export const buildQueueItemId = ({ projectId, scopeKey, documentCode }) => [
  normalizeKeyPart(projectId),
  normalizeKeyPart(scopeKey),
  normalizeKeyPart(documentCode),
].join('::');

export const buildQueueItem = ({
  projectId,
  scopeKey,
  documentCode,
  formData,
  localVersion,
  action = 'SAVE_DRAFT',
  retryCount = 0,
  status = 'PENDING',
  lastError = '',
  conflictData = null,
}) => {
  const now = new Date().toISOString();
  return {
    id: buildQueueItemId({ projectId, scopeKey, documentCode }),
    projectId: Number(projectId),
    scopeKey,
    documentCode,
    formData: formData || {},
    localVersion: Number(localVersion) || 1,
    action,
    status,
    retryCount: Number(retryCount) || 0,
    lastError,
    conflictData,
    queuedAt: now,
    updatedAt: now,
  };
};

export const parseQueue = (rawValue) => {
  if (!rawValue) return [];
  try {
    const parsed = JSON.parse(rawValue);
    return Array.isArray(parsed) ? parsed.filter((item) => item?.id) : [];
  } catch (error) {
    return [];
  }
};

export const readQueue = (storage = window.localStorage) => parseQueue(storage.getItem(OFFLINE_SYNC_QUEUE_KEY));

export const writeQueue = (queue, storage = window.localStorage) => {
  storage.setItem(OFFLINE_SYNC_QUEUE_KEY, JSON.stringify(Array.isArray(queue) ? queue : []));
};

export const upsertQueueItem = (queue, item) => {
  const current = Array.isArray(queue) ? queue : [];
  const existing = current.find((entry) => entry.id === item.id);
  if (!existing) return [...current, item];
  return current.map((entry) => (
    entry.id === item.id
      ? {
        ...entry,
        ...item,
        retryCount: item.retryCount ?? entry.retryCount ?? 0,
        queuedAt: entry.queuedAt || item.queuedAt,
        updatedAt: new Date().toISOString(),
      }
      : entry
  ));
};

export const updateQueueItemStatus = (queue, itemId, patch) => (
  (Array.isArray(queue) ? queue : []).map((entry) => (
    entry.id === itemId
      ? {
        ...entry,
        ...patch,
        retryCount: patch.retryCount ?? entry.retryCount ?? 0,
        updatedAt: new Date().toISOString(),
      }
      : entry
  ))
);

export const removeQueueItem = (queue, itemId) => (
  (Array.isArray(queue) ? queue : []).filter((entry) => entry.id !== itemId)
);

export const summarizeQueue = (queue) => {
  const items = Array.isArray(queue) ? queue : [];
  return items.reduce((summary, item) => {
    const status = item.status || 'PENDING';
    return {
      total: summary.total + 1,
      pending: summary.pending + (status === 'PENDING' ? 1 : 0),
      syncing: summary.syncing + (status === 'SYNCING' ? 1 : 0),
      failed: summary.failed + (status === 'FAILED' ? 1 : 0),
      conflict: summary.conflict + (status === 'CONFLICT' ? 1 : 0),
    };
  }, {
    total: 0,
    pending: 0,
    syncing: 0,
    failed: 0,
    conflict: 0,
  });
};

export const hasConflict = (responseData) => (
  !!responseData?.conflictData && Object.keys(responseData.conflictData).length > 0
);
